import React from 'react';
import DateTimeReact from 'react-datetime';
import moment from 'moment';

import './DateTimeInput.css';
import {t} from "i18next";

const DateTimePicker = (props) => {
    const { 
        label,
        value, 
        onChange,
        dateFormat: dateFormatProp, 
        showTime, 
        placeholderText, 
        closeOnSelect: closeOnSelectProp, 
        isValidDate,
        showTimezone,
        required
    } = props;

    const onBlur = (datetime) => {
        const newValue = (!datetime || !datetime._isAMomentObject) 
            ? "" 
            : (dateFormatProp === false) 
                ? datetime.format("HH:mm") 
                : datetime.format('YYYY-MM-DD HH:mm');

        onChange && onChange(newValue, datetime ? datetime._d : null);
    };

    moment.updateLocale('en', {
        week: {
          dow: 1,
        },
    });

    const timeFormat = (showTime === false) ? "" : "HH:mm";
    const dateFormat = (dateFormatProp === undefined) ? "YYYY-MM-DD" : (dateFormatProp === false) ? false : "YYYY-MM-DD";
    const placeHolderDateFormat = placeholderText !== undefined 
        ? placeholderText 
        : (dateFormatProp === undefined && timeFormat === "HH:mm") 
            ? "YYYY-MM-DD HH:mm" 
            : (dateFormatProp === false) 
                ? "HH:mm" 
                : "YYYY-MM-DD";
    const closeOnSelect = closeOnSelectProp !== false;
    const dateValue = dateFormatProp === false && value ? value.toString("HH:mm") : value ? moment(value) : undefined;
    
    const inputProps = {
        dateFormat: dateFormat,
        timeFormat: timeFormat,
        inputProps: {placeholder: placeHolderDateFormat},
        onChange: onBlur,
        closeOnSelect: closeOnSelect,
        value: dateValue,
        ...(isValidDate && { isValidDate: isValidDate })
    };

    const getTimezoneName = () => {
        try {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (error) {
            return `UTC${moment().format('Z')}`;
        }
    };

    return (
        <div className={`form-control${required ? ' required' : ''}`}>
            <label className="control-label">
                {label}
            </label>
            <DateTimeReact {...inputProps} />
            {showTimezone && (
                <small className="text-muted" style={{display: 'block', marginTop: '5px'}}>
                    {t("dateTimePicker.timezone")}: {getTimezoneName()}
                </small>
            )}
        </div>
    );
};

export default DateTimePicker;

